import { render } from "./MessagesBody.vue?vue&type=template&id=4618b892&ts=true"
import script from "./MessagesBody.vue?vue&type=script&lang=ts"
export * from "./MessagesBody.vue?vue&type=script&lang=ts"

import "./MessagesBody.vue?vue&type=style&index=0&id=4618b892&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Messages/MessagesBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4618b892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4618b892', __exports__)) {
    api.reload('4618b892', __exports__)
  }
  
  module.hot.accept("./MessagesBody.vue?vue&type=template&id=4618b892&ts=true", () => {
    api.rerender('4618b892', render)
  })

}


export default __exports__